export const FETCH_DASHBOARD_HEADER_COUNTS_PENDING = '[DASHBOARD][FETCH] pending fetch dashboard counts';
export const FETCH_DASHBOARD_HEADER_COUNTS_SUCCESS = '[DASHBOARD][FETCH] success fetch dashboard counts';
export const FETCH_DASHBOARD_HEADER_COUNTS_FAILURE = '[DASHBOARD][FETCH] failure  fetch dashboard counts';
export const GET_ENGAGEMENTS_PENDING = '[DASHBOARD][FETCH] pending fetch engagements';
export const GET_ENGAGEMENTS_SUCCESS = '[DASHBOARD][FETCH] success fetch engagements';
export const GET_ENGAGEMENTS_FAILURE = '[DASHBOARD][FETCH] feilure fetch engagements';
export const GET_CASE_PHASES_SUCCESS = '[DASHBOARD][FETCH] success fetch case phases';
export const STORE_SELECTED_MESSAGE_ID = '[DASHBOARD][STORE] store selected message id';
export const STORE_SELECTED_ENGAGEMENT = '[DASHBOARD][STORE] store selected engagement';
export const RESET_SELECTED_MESSAGE_ID = '[DASHBOARD][RESET] reset selected message id';
export const GET_FAVORITE_CASE = '[DASHBOARD][FAVORITE] get favorite case';
export const SET_DASHBORD_CASE_UPDATE = '[DASHBOARD][FAVORITE] update favorite case checkbox';

const json = {
  FETCH_DASHBOARD_HEADER_COUNTS_PENDING,
  FETCH_DASHBOARD_HEADER_COUNTS_SUCCESS,
  FETCH_DASHBOARD_HEADER_COUNTS_FAILURE,
  STORE_SELECTED_MESSAGE_ID,
  STORE_SELECTED_ENGAGEMENT,
};

export default json;



// WEBPACK FOOTER //
// ./src/ui/features/Dashboard/state/dashboardTypes.js